import React, {FunctionComponent} from "react";
import {useIntl} from "react-intl";
import GenericModal from "../GenericModal";
import {clipboardUtils} from "../../../../utils/clipboardUtils";
import {toastUtils} from "../../../../utils/toastUtils";

interface ModalResourceEmailsProps {
  className?: string,
  open: boolean,
  onOpen: (open: boolean) => void,
  emails: string[],
}

const ModalResourceEmails: FunctionComponent<ModalResourceEmailsProps> = ({
  className = "",
  open,
  onOpen,
  emails
}) => {
  const intl = useIntl()
  const emailList = emails?.join("; ") ?? ""

  const copyEmails = () => {
    clipboardUtils.copyToClipboard(emailList)
      .then(() => toastUtils.successToast(intl.formatMessage({id: "success_toast_copy_resource_emails"})))
      .catch(() => toastUtils.errorToast(intl.formatMessage({id: "error_toast_copy_resource_emails"})))
  }

  return (
    <GenericModal
      className={className}
      title={intl.formatMessage({id: "modal_title_resource_emails"})}
      open={open}
      onOpen={onOpen}
      closable
      enableClickOutside
      footer={{
        primaryAction: {
          buttonLabel: intl.formatMessage({id: "copy_button"}),
          action: copyEmails,
          disabled: !emailList
        },
        secondaryAction: {
          buttonLabel: intl.formatMessage({id: "close_button"}),
          action: () => onOpen(false)
        }
      }}
    >
      {emailList ? (
        <div className="d-flex flex-column w-100">
          <span className="mb-2">
            {intl.formatMessage({id: "modal_body_resource_emails_count"}, {count: emails.length})}
          </span>
          <textarea className="form-control" rows={8} value={emailList} readOnly />
        </div>
      ) : (
        <p className="text-muted m-0">
          {intl.formatMessage({id: "modal_body_resource_emails_empty"})}
        </p>
      )}
    </GenericModal>
  )
}

export default ModalResourceEmails
